
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.963 23.391a7.429 7.429 0 110-14.857 7.429 7.429 0 110 14.857m0-23.392C7.147 0 0 7.146 0 15.962c0 8.817 15.963 23.293 15.963 23.293S31.926 24.78 31.926 15.962C31.926 7.146 24.779 0 15.963 0"}})])
          )
        }
      }
    